<template>
  <div>
    <div id="profit">
      <div>
        <div style="display:inline-block">
          <el-input v-model="para.orderId" placeholder="请输入销售合同号" @change="(value) => {return handleSearch(0, value)}"></el-input>
        </div>
      </div>
      <div class="comond_btn">
        <el-button  @click="handleSet('add', null)" >补货</el-button>
      </div>
  </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      para: {
        orderId: ''
      }
    }
  },
  methods: {
    handleSearch () {

    },
    handleSet () {
      
    }
  },

}
</script>

<style lang="stylus" scoped>
#profit
  display flex
  justify-content space-between
  .comond_btn
    display flex
    justify-content flex-end
    margin-bottom 30px
    button
      background-color #0a3d5f
      color #fff
</style>

